// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c2fb5c32","977":"c1ec83bd"}[chunkId] + ".chunk.js";
};